const local = {
  client: '2MSV0H0QJV',
  redirect: 'http://0.0.0.0:8000',
}

const prod = {
  client: '0S7U6G6D6L',
  redirect: 'http://exports.iloyalty.io',
}

const auth = prod

export default {
  endpoint: 'https://sso0.iloyalty.io/api/v1',
  url: 'https://sso0.iloyalty.io/oauth/authorize',
  client: auth.client,
  redirect: auth.redirect,
  scope: 'sso-tool',
}

export const types = [
  { name: 'Bestellingen (per order)', id: 'orders_by_order', disabled: false },
  { name: 'Bestellingen (per regel)', id: 'orders_by_line', disabled: false },
  { name: 'Gebruikers', id: 'users', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  { name: 'Segmenten', id: 'segments', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  { name: 'Producten (marge)', id: 'products', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  { name: 'Leveranciers', id: 'suppliers', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Transacties punten', id: 'credits_transactions', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Transactie-log', id: 'transactions', disabled: true },
  // { name: 'Punten per gebruiker', id: 'credits_by_user', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Winactie - statistieken', id: 'campaign_giveaway_stats', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Winactie - aanmeldingen', id: 'campaign_giveaway_submissions', disabled: false, disabledForProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Budget (totalen)', id: 'budget_totals', disabled: false, disabledUnlessProject: ['598077b74299993401f3f5f8'] },
  // { name: 'Budget (transacties)', id: 'budget_transactions', disabled: false, disabledUnlessProject: ['598077b74299993401f3f5f8'] },
]



// WEBPACK FOOTER //
// ./config.js